import { useInfiniteQuery } from "@tanstack/react-query";
import { GetAreaPayload } from "../type";
import { AreaMessageService } from "..";

type Props = {
  params: GetAreaPayload;
};

function useGetRegion({ params }: Props) {
  const { data, isLoading, refetch, hasNextPage, fetchNextPage, isError, isFetchingNextPage } =
    useInfiniteQuery({
      queryKey: ["getRegion", params.Term],
      queryFn: ({ pageParam = 0 }) =>
        AreaMessageService.getArea({ ...params, Skip: pageParam }),
      getNextPageParam: (lastPage, allPages) => {

        const itemsFetched = allPages.flatMap((page) => page).length;
        if (lastPage?.length > 0) {
          // There are more items to fetch
          return itemsFetched;
        } else {
          // No more items to fetch
          return undefined;
        }
      },
    });

  return { data, isLoading, refetch, hasNextPage, fetchNextPage, isError, isFetchingNextPage };
}

export default useGetRegion;
